import styled from 'styled-components';
import clock from '~/assets/icons/clock.svg';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: 20px;
	width: 380px;
	background: rgba(255, 255, 255, 0.02);
	border-radius: 5px;
`;

const StyledRemainingContainer = styled.div`
	display: flex;
	justify-content: space-between;

	${Text} {
		font-weight: 400;
		font-size: 14px;
		line-height: 16px;
		color: rgba(255, 255, 255, 0.5);

		span {
			font-weight: 700;
			color: #ffffff;
		}
	}
`;

const StyledStorageItemTopContainer = styled.div`
	display: grid;
	grid-template-columns: 110px 30px 1fr;
	align-items: center;
	gap: 20px;
`;

const StyledTimeContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr auto 16px;
	align-items: center;
	gap: 10px;

	${Text} {
		font-size: 14px;
		color: #ffffff;
	}

	.icon {
		width: 16px;
		height: 16px;
		mask-image: url(${clock});
		mask-size: 100% 100%;
		mask-repeat: no-repeat;
		mask-position: center;
		-webkit-mask-image: url(${clock});
		-webkit-mask-size: 100% 100%;
		-webkit-mask-repeat: no-repeat;
		-webkit-mask-position: center;
		background-color: #ffbb00;
	}
`;

const StyledButtonsGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px;

	button {
		${Text} {
			font-size: 14px;
		}
	}
`;

const StyledHint = styled.div`
	position: fixed;
	transform: translateX(-50%);
	padding: 0 10px;
	height: 40px;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(255, 255, 255, 0.9);
	border-radius: 10px;
	transition: opacity 0.2s ease;
	z-index: 10000;

	${Text} {
		font-size: 14px;
		color: #000000;
		white-space: nowrap;
	}
`;

export {
	StyledButtonsGrid,
	StyledContainer,
	StyledHint,
	StyledRemainingContainer,
	StyledStorageItemTopContainer,
	StyledTimeContainer,
};
